@if (open && url) {
  <div
    class="image-preview-overlay"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="mediaType === 'video' ? 'Video preview' : 'Image preview'"
    (click)="onOverlayClick()"
  >
    <div
      class="image-preview-stage"
      [class.image-preview-stage--with-nav]="showNavigation"
      (click)="$event.stopPropagation()"
    >
      @if (showNavigation) {
        <button
          type="button"
          class="image-preview-nav image-preview-nav--prev"
          [attr.aria-label]="prevLabel"
          nz-tooltip
          [nzTooltipTitle]="prevLabel"
          [disabled]="!canNavigatePrev"
          (click)="onPrevClick($event)"
        >
          <app-icon name="chevron-left" [size]="22"></app-icon>
        </button>
      }

      <div
        class="image-preview-modal"
        [class.image-preview-modal--with-filmstrip]="thumbnails.length > 1"
      >
        <button
          type="button"
          class="image-preview-close"
          aria-label="Close preview"
          (click)="onCloseClick($event)"
        >
          <app-icon name="x" [size]="16"></app-icon>
        </button>

        @if (displayTitle || subtitle) {
          <div class="image-preview-meta">
            @if (displayTitle) {
              <span class="image-preview-title">{{ displayTitle }}</span>
            }
            @if (subtitle) {
              <span class="image-preview-sub">{{ subtitle }}</span>
            }
          </div>
        }

        <div class="image-preview-image-wrap">
          @if (showToolbarActions) {
            <div class="image-preview-toolbar">
              @if (showEdit) {
                <button
                  type="button"
                  class="image-preview-toolbar-btn image-preview-toolbar-btn--edit"
                  [class.image-preview-toolbar-btn--icon-only]="portraitCompact"
                  [disabled]="editDisabled"
                  nz-tooltip
                  [nzTooltipTitle]="editTooltip"
                  (click)="onEditClick($event)"
                >
                  <app-icon name="edit" [size]="12"></app-icon>
                  <!-- @if (!portraitCompact) {
                    <span>Edit</span>
                  } -->
                </button>
              }
              @if (showGenerate) {
                <button
                  type="button"
                  class="image-preview-toolbar-btn image-preview-toolbar-btn--generate"
                  [class.image-preview-toolbar-btn--icon-only]="portraitCompact"
                  [disabled]="generateDisabled"
                  nz-tooltip
                  [nzTooltipTitle]="generateTooltip"
                  (click)="onGenerateClick($event)"
                >
                  <app-icon name="zap" [size]="12"></app-icon>
                  <!-- @if (!portraitCompact) {
                    <span>Generate More</span>
                  } -->
                </button>
              }
              @if (showUpscaleButton) {
                <button
                  type="button"
                  class="image-preview-toolbar-btn image-preview-toolbar-btn--upscale"
                  [class.image-preview-toolbar-btn--icon-only]="portraitCompact"
                  [disabled]="upscaleDisabled"
                  nz-tooltip
                  [nzTooltipTitle]="upscaleTooltip"
                  (click)="onUpscaleClick($event)"
                >
                  <app-icon name="expand-diagonal" [size]="12"></app-icon>
                  <!-- @if (!portraitCompact) {
                    <span>Upscale</span>
                  } -->
                </button>
              }
              @if (showDownload) {
                <button
                  type="button"
                  class="image-preview-toolbar-btn image-preview-toolbar-btn--download image-preview-toolbar-btn--icon-only"
                  [disabled]="downloadDisabled"
                  nz-tooltip
                  [nzTooltipTitle]="downloadTooltip"
                  (click)="onDownloadClick($event)"
                >
                  <app-icon name="download" [size]="12"></app-icon>
                </button>
              }
            </div>
          }
          @if (showCompareToggle) {
            <div class="image-preview-compare-toggle" role="group" aria-label="Compare edited and original">
              <button
                type="button"
                class="image-preview-compare-btn"
                [class.image-preview-compare-btn--active]="!showOriginalImage"
                (click)="setCompareView(false, $event)"
              >
                Edited
              </button>
              <button
                type="button"
                class="image-preview-compare-btn"
                [class.image-preview-compare-btn--active]="showOriginalImage"
                (click)="setCompareView(true, $event)"
              >
                Original
              </button>
            </div>
          }
          @if (mediaType === "image") {
            <div class="image-preview-zoom" (click)="$event.stopPropagation()" role="group" aria-label="Image zoom controls">
              <button
                type="button"
                class="image-preview-zoom-btn"
                aria-label="Zoom in"
                [disabled]="zoom >= 3"
                (click)="stepZoom(0.25)"
              >
                <app-icon name="search-plus" [size]="13"></app-icon>
              </button>
              <div class="image-preview-zoom-track">
                <input class="image-preview-zoom-slider" type="range" min="1" max="3" step="0.1"
                  [style.--zoom-fill]="zoomFill" [value]="zoom" aria-label="Zoom image"
                  (input)="onZoomChange($event)" />
              </div>
              <button
                type="button"
                class="image-preview-zoom-btn"
                aria-label="Zoom out"
                [disabled]="zoom <= 1"
                (click)="stepZoom(-0.25)"
              >
                <app-icon name="search-minus" [size]="13"></app-icon>
              </button>
            </div>
            @if (prompt.trim()) {
              <button
                type="button"
                class="image-preview-prompt-btn"
                aria-label="View generation prompt"
                nz-popover
                [nzPopoverContent]="imagePromptPopoverTpl"
                nzPopoverTrigger="hover"
                nzPopoverPlacement="left"
                nzPopoverOverlayClassName="variation-recipe-popover-overlay"
                (click)="$event.stopPropagation()"
              >
                <app-icon name="ai-sparkle" [size]="13"></app-icon>
              </button>
              <ng-template #imagePromptPopoverTpl>
                <div
                  class="variation-instruction-popover variation-prompt-popover"
                >
                  <div class="variation-instruction-popover-title">
                    Generation prompt
                  </div>
                  <p class="variation-instruction-popover-text">
                    {{ prompt }}
                  </p>
                </div>
              </ng-template>
            }
          }
          @if (mediaType === "video") {
            <video
              class="image-preview-video"
              [src]="url"
              controls
              autoplay
              playsinline
            ></video>
          } @else {
            <img #previewImage class="image-preview-img" [class.image-preview-img--draggable]="zoom > 1"
              [src]="displayUrl" [alt]="alt" [style.transform]="imageTransform"
              (pointerdown)="onImagePointerDown($event, previewImage)"
              (pointermove)="onImagePointerMove($event, previewImage)"
              (pointerup)="onImagePointerUp($event)" (pointercancel)="onImagePointerUp($event)"
              (wheel)="onImageWheel($event)" />
          }
          @if (badges.length) {
            <div class="image-preview-badges">
              @for (badge of badges; track badge.label + $index) {
                @if (isEditedBadgeWithInfo(badge)) {
                  <div
                    class="image-preview-badge-wrap"
                    (mouseenter)="openEditInfoPanel()"
                    (mouseleave)="onEditInfoPanelMouseLeave()"
                  >
                    <div
                      [ngClass]="badgeClass(badge)"
                      [class.image-preview-badge--icon-only]="hideBadgeLabel(badge)"
                    >
                      @if (badgeIcon(badge); as iconName) {
                        <app-icon
                          [name]="iconName"
                          [size]="isStatusBadge(badge) ? 12 : 10"
                        ></app-icon>
                      }
                      @if (!hideBadgeLabel(badge)) {
                        <span>{{ badge.label }}</span>
                      }
                      <app-icon
                        name="info"
                        [size]="10"
                        class="image-preview-badge-info-icon"
                      ></app-icon>
                    </div>
                    @if (editInfoPanelVisible) {
                      <div
                        class="image-preview-edit-info-flyout variation-instruction-popover"
                        (mouseenter)="onEditInfoPanelMouseEnter()"
                        (mouseleave)="onEditInfoPanelMouseLeave()"
                        (click)="$event.stopPropagation()"
                      >
                        @if (editLlmLoading) {
                          <div class="image-preview-edit-info-loading">
                            <span class="image-preview-edit-info-spinner"></span>
                            <span>Loading edit details…</span>
                          </div>
                        } @else if (editLlmLoadError) {
                          <p class="variation-instruction-popover-text">
                            {{ editLlmLoadError }}
                          </p>
                        } @else if (!editLlmEdits.length) {
                          <p class="variation-instruction-popover-text">
                            No edit details available.
                          </p>
                        } @else {
                          @for (edit of editLlmEdits; track $index) {
                            <div
                              class="image-preview-edit-info-item"
                              [class.image-preview-edit-info-item--spaced]="
                                $index > 0
                              "
                            >
                              <div class="variation-instruction-popover-title">
                                {{ getEditLlmItemTitle(edit) }}
                              </div>
                              <p class="variation-instruction-popover-text">
                                {{ getEditLlmItemBody(edit) }}
                              </p>
                            </div>
                          }
                        }
                      </div>
                    }
                  </div>
                } @else {
                  <div
                    [ngClass]="badgeClass(badge)"
                    [class.image-preview-badge--icon-only]="hideBadgeLabel(badge)"
                    nz-tooltip
                    [nzTooltipTitle]="badgeTooltip(badge)"
                  >
                    @if (badgeIcon(badge); as iconName) {
                      <app-icon
                        [name]="iconName"
                        [size]="isStatusBadge(badge) ? 12 : 10"
                      ></app-icon>
                    }
                    @if (!hideBadgeLabel(badge)) {
                      <span>{{ badge.label }}</span>
                    }
                  </div>
                }
              }
            </div>
          }
        </div>

        @if (thumbnails.length > 1) {
          <div
            class="image-preview-filmstrip"
            role="listbox"
            aria-label="Shot variations"
          >
            @for (thumbnail of thumbnails; track thumbnail.id; let i = $index) {
              <button
                type="button"
                class="image-preview-thumbnail"
                [class.image-preview-thumbnail--active]="
                  i === activeThumbnailIndex
                "
                [attr.aria-selected]="i === activeThumbnailIndex"
                [attr.aria-label]="
                  thumbnail.label || 'Variation ' + (i + 1)
                "
                role="option"
                nz-tooltip
                [nzTooltipTitle]="
                  thumbnail.label || 'Variation ' + (i + 1)
                "
                (click)="onThumbnailClick(i, $event)"
              >
                <img
                  [src]="thumbnail.url"
                  [alt]="thumbnail.label || 'Variation ' + (i + 1)"
                />
                @if (thumbnail.status) {
                  <span class="image-preview-thumbnail-status">
                    {{ thumbnail.status }}
                  </span>
                }
              </button>
            }
          </div>
        }

        @if (showApprovalActions) {
          <div class="image-preview-actions">
            @if (showMarkReadyForReview) {
              <button
                type="button"
                class="image-preview-action image-preview-action--ready"
                [disabled]="markReadyForReviewDisabled"
                nz-tooltip
                nzTooltipTitle="Flag this variation for review"
                (click)="markReadyForReview.emit()"
              >
                <app-icon name="clock" [size]="12"></app-icon>
                <span>Mark for Review</span>
              </button>
            }
            @if (showRemoveFromReadyForReview) {
              <button
                type="button"
                class="image-preview-action image-preview-action--remove"
                [disabled]="removeFromReadyForReviewDisabled"
                nz-tooltip
                nzTooltipTitle="Remove this from review"
                (click)="removeFromReadyForReview.emit()"
              >
                <app-icon name="x" [size]="12"></app-icon>
              </button>
            }
            @if (showRevokeApproval) {
              <button
                type="button"
                class="image-preview-action image-preview-action--remove image-preview-action--labeled"
                [disabled]="revokeApprovalDisabled"
                nz-tooltip
                nzTooltipTitle="Revoke approval for this variation"
                (click)="revokeApproval.emit()"
              >
                <app-icon name="x" [size]="12"></app-icon>
                <span>Revoke Approval</span>
              </button>
            }
            @if (showApprove) {
              <button
                type="button"
                class="image-preview-action image-preview-action--approve"
                [disabled]="approveDisabled"
                nz-tooltip
                [nzTooltipTitle]="approveTooltip"
                (click)="approve.emit()"
              >
                <app-icon name="check-circle" [size]="12"></app-icon>
                <span>Approve</span>
              </button>
            }
          </div>
        }
      </div>

      @if (showNavigation) {
        <button
          type="button"
          class="image-preview-nav image-preview-nav--next"
          [attr.aria-label]="nextLabel"
          nz-tooltip
          [nzTooltipTitle]="nextLabel"
          [disabled]="!canNavigateNext"
          (click)="onNextClick($event)"
        >
          <app-icon name="chevron-right" [size]="22"></app-icon>
        </button>
      }
    </div>
  </div>
}
